import { Avatar, List, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { workFlowItem, data } from "./workFlowData";
import ItemModal from "./ItemModal";
import "./style.css";
import { collection, doc, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";

const WorkFlow = ({ setIsModalOpen }) => {
  const [selectedWorkFlow, setSelectedWorkFlow] = useState(null);
  const [isShowItemModal, setIsShowItemModal] = useState(false);
  const [modalId, setModalId] = useState(null);
  const [itemsList, setItemsList] = useState([]);

  const showItemModal = (id) => {
    console.log("index:---", id);
    setModalId(id);
    setIsShowItemModal(true);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsShowItemModal(false);
  };

  const fetchItemList = async () => {
    try {
      const tasksRef = collection(db, "tasks");
      const itemListRef = doc(tasksRef, "itemList");
      const listData = collection(itemListRef, "items");

      const querySnapshot = await getDocs(listData);
      const allItems = querySnapshot.docs.map((doc) => doc.data());

      const sortedData = allItems.sort((a, b) => {
        if(a.title < b.title) { return -1; }
        if(a.title > b.title) { return 1; }
        return 0;
      });
      setItemsList(sortedData);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };

  useEffect(() => {
    fetchItemList();
    console.log(":::::::::::::::::::::")
  }, []);

  return (
    <div className="workFlow">
      <Select
        allowClear
        showSearch
        placeholder="Search workflows"
        style={{
          width: "100%",
          marginTop: "30px",
        }}
        options={workFlowItem}
        onChange={(value) => setSelectedWorkFlow(value)}
      />

      <p
        style={{
          padding: "10px 0",
          borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
        }}
      >
        WORKFLOWS
      </p>
      <List
        itemLayout="horizontal"
        dataSource={
          selectedWorkFlow
            ? itemsList?.filter((item) => item.title.includes(selectedWorkFlow))
            : itemsList
        }
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <div className="listItemAction">
                <a
                  key="list-loadmore-more"
                  onClick={() => showItemModal(item.title)}
                >
                  <i className="fa-solid fa-play workFlowListIcon"></i>
                </a>
              </div>,
            ]}
          >
            <List.Item.Meta
              avatar={<span>{item.emoji}</span>}
              title={<span>{item.title}</span>}
              description={item.description}
              onClick={() => showItemModal(item.title)}
              style={{ cursor: "pointer" }}
            />
          </List.Item>
        )}
      />

      <Modal
        title={
          <span>
            <i className="fa-solid fa-play"> </i> Run Workflow
          </span>
        }
        open={isShowItemModal}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <ItemModal modalId={modalId} setIsShowItemModal={setIsShowItemModal} itemsList={itemsList}/>
      </Modal>
    </div>
  );
};

export default WorkFlow;
